export const MAX_INSURER_ROWS = 30;
